import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.146 8.854c.195.195.512.195.707 0l3-3c.195-.195.195-.512 0-.707s-.512-.195-.707 0L10 7.293V1.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v5.793L6.854 5.147a.5003.5003 0 0 0-.707 0c-.098.098-.146.226-.146.354s.049.256.146.354l3 3z',
    'M18.853 11.144l-2.998-2.998c-.04-.04-.088-.067-.137-.091-.009-.004-.016-.013-.025-.016A.4967.4967 0 0 0 15.5 8h-2.501c-.276 0-.5.224-.5.5s.224.5.5.5h2.295l2 2H1.704l2-2h2.295c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H3.498c-.066 0-.131.013-.193.039-.009.004-.015.012-.024.016-.049.024-.097.051-.137.091L.146 11.144c-.148.148-.147.739-.147.856v5c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-5s.006-.703-.147-.856zM13 13c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-1h7v1z',
  ],
  height: 20,
  width: 20,
});
